/**
 *
 * Jira
 *
 */

import React, { memo } from 'react';

import { JiraWizard } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Jira/Components/JiraWizard';

import { useIntegrationsContext } from '../../../context/context';

import { JiraTable } from './Components/JiraTable';

export const Jira = memo(() => {
  const { isOpen } = useIntegrationsContext();

  return <>{isOpen ? <JiraWizard /> : <JiraTable />}</>;
});
